var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { GGOBaseComponent } from '../ggo.base.component.js';
import { Icon } from '../../utils/icon-utils.js';
import { EditableLabelEvent } from './editable-label.event.js';
import { Translate } from '../../utils/translate.js';
let EditableLabelComponent = class EditableLabelComponent extends GGOBaseComponent {
    static get styles() {
        return [
            ...super.styles,
            css `
        .ggo-label {
          cursor: pointer;
          line-height: 1.65rem;
        }
        input {
          border-radius: 0.25rem;
          border: none;
          box-shadow: 0 0 1px 1px #1b96ff;
          outline-width: 0;
          padding: 0.125rem 0.375rem;
          width: 7rem;
        }
        .slds-icon_xx-small {
          fill: #747474;
        }
        .to_validate_icon > span > svg {
          fill: #1b96ff;
        }
        .to_validate_icon > span > svg:hover {
          fill: #0176d3;
        }
        .to_edit_icon > span > svg:hover {
          fill: #1b96ff;
        }
      `,
        ];
    }
    constructor() {
        super();
        this.editMode = false;
        this.labelClickable = true;
        this._onOutsideClick = (e) => {
            if (!this.contains(e.target)) {
                this.editMode = false;
                window.removeEventListener('mousedown', this._onOutsideClick);
                this.requestUpdate();
            }
        };
        this.label = '';
        this.editMode = false;
    }
    _handleClick(e) {
        const labelChanged = e.target.value !== this.label;
        this.label = e.target.value;
        const eventData = { label: this.label };
        if (this.id)
            eventData.detail['id'] = this.id;
        if (this.object && this.objectProperty) {
            // Edit the object property directly
            this.object[this.objectProperty] = this.label;
        }
        if (labelChanged) {
            this.dispatchEvent(new EditableLabelEvent(eventData));
        }
        this._toggleEditMode(e);
    }
    _toggleEditMode(e) {
        e.stopPropagation();
        this.editMode = !this.editMode;
        if (this.editMode) {
            window.addEventListener('mousedown', this._onOutsideClick);
        }
        else {
            window.removeEventListener('mousedown', this._onOutsideClick);
        }
    }
    render() {
        if (this.object && this.objectProperty) {
            this.label = this.object[this.objectProperty];
        }
        if (this.editMode) {
            return html `
        <input
          type="text"
          value="${this.label}"
          autofocus
          @change="${this._handleClick}"
          @mousedown="${(e) => e.stopPropagation()}"
          @click="${(e) => e.stopPropagation()}"
        />
        <div
          title="${Translate.get('editable_label_validate')}"
          class="slds-icon_container to_validate_icon"
          @click="${(e) => this._toggleEditMode(e)}"
        >
          ${Icon.getSVGIconTag({ icon: 'check', sprite: 'utility', classes: ['slds-icon_xx-small', 'ggo-label'] })}
        </div>
      `;
        }
        else {
            const title = this.getAttribute('title') ?? Translate.get('editable_label_edit');
            return html `
        <span
          ${this.labelClickable ? html `title="${title}"` : nothing}
          class="ggo-label"
          @click="${(e) => {
                if (this.labelClickable)
                    this._toggleEditMode(e);
            }}"
          >${this.label}</span
        >
        <div title="${title}" class="slds-icon_container to_edit_icon" @click="${(e) => this._toggleEditMode(e)}">
          ${Icon.getSVGIconTag({ icon: 'edit', sprite: 'utility', classes: ['slds-icon_xx-small', 'ggo-label'] })}
        </div>
      `;
        }
    }
};
__decorate([
    property({ type: String })
], EditableLabelComponent.prototype, "label", void 0);
__decorate([
    property({ type: Object })
], EditableLabelComponent.prototype, "object", void 0);
__decorate([
    property({ type: String })
], EditableLabelComponent.prototype, "objectProperty", void 0);
__decorate([
    property({ type: Boolean })
], EditableLabelComponent.prototype, "editMode", void 0);
__decorate([
    property({ type: Boolean })
], EditableLabelComponent.prototype, "labelClickable", void 0);
EditableLabelComponent = __decorate([
    customElement('ggo-editable-label')
], EditableLabelComponent);
export { EditableLabelComponent };
